<form [ngrxFormState]="form" *ngIf="form$|async; let form" class="w-100" autocomplete="off" role="presentation">
    <div class="content">
        <div class="row">
            <div class="col col-md-12 p-0">

                <div class="col-12 p-0">
                    <app-entry class="entry-dark-bg" title="Tax file number" placeholder="###-###-###"
                        [control]="form.controls.tfn">
                    </app-entry>
                </div>

                <div class="col-12 p-0">

                    <div class="privacy">
                        <p>I declare that I have read and understood the important information about my Tax File Number
                            (TFN) in the <a href="https://vervesuper.com.au/docs/product-disclosure-statement"
                                target="_blank">Product Disclosure Statement</a> and consent to the use of my TFN for
                            the legal
                            purposes stated, which may include creating and administering my account, using the ATO’s
                            SuperMatch service to find my lost or inactive accounts, and actioning my rollover
                            requests. 
                        </p>
                        <p>
                            Under the Superannuation Industry (Supervision) Act 1993, the Trustee is authorised to
                            collect, use and disclose your TFN and use it for lawful purposes to administer your
                            superannuation interest and to provide information relating to your super to the ATO under
                            government legislation. Your TFN may be disclosed to another superannuation provider when
                            transferring your super, unless you request not to do so in writing. The lawful purposes for
                            which your TFN can be used, and the consequences for not quoting your TFN, may change in the
                            future, as a result of legislative changes. It's not compulsory to provide a TFN when
                            opening a super account, nor is it an offence not to do so. If you don’t tell us your TFN,
                            your before-tax contributions and withdrawals will be taxed at a higher rate, we can’t
                            accept after-tax contributions from you, and we will not be able to use the ATO's SuperMatch
                            service to find your lost or inactive accounts and action your rollover requests. For these
                            reasons, Verve Super has decided that we will not open an account in your name without a
                            valid TFN. For more information, refer to the <a
                                href="https://vervesuper.com.au/docs/product-disclosure-statement"
                                target="_blank">Product Disclosure Statement</a>, <a href="https://vervesuper.com.au/privacy-policy" target="_blank">Privacy
                                Policy</a> or <a href="https://vervesuper.com.au/contact-us" target="_blank">contact us</a> if you have any questions.
                        </p>
                        <app-checkbox class="entry-dark-bg" title="I have read, understood and agree to the above"
                            [control]="form.controls.tfnAgreement">
                        </app-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 col-12 p-0">
        <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
        </app-button>
        <app-button class="custom" title="Next" [isDisabled]="(isLoading$ | async) || form.isInvalid" icon="east"
            loading (onClick)="onMoveNextClick(form)">
        </app-button>
    </div>
    <div class="footer footer-mobile col-12 mt-5 p-0">
        <ng-template class="" [ngTemplateOutlet]="FooterStep4"></ng-template>
    </div>
</form>

<ng-template #FooterStep4>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>